import { render, staticRenderFns } from "./InferenceEngineVersion.vue?vue&type=template&id=5197255d"
import script from "./InferenceEngineVersion.vue?vue&type=script&lang=js"
export * from "./InferenceEngineVersion.vue?vue&type=script&lang=js"
import style0 from "./InferenceEngineVersion.vue?vue&type=style&index=0&id=5197255d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports